import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';

import eq from 'webapp/helpers/eq';
import didInsert from 'webapp/modifiers/did-insert';
import type { OptionRaw } from 'webapp/components/form/select';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

export interface PopupData {
	options: OptionRaw<number>[];
	onChange: (item: OptionRaw<number>) => void;
}

export default class UserPopupRoleSelectComponent extends PopupInnerContextComponent<PopupData> {
	arrowNode: HTMLElement | null = null;

	get options() {
		return this.popupData.options;
	}

	@action
	toggleHoverClass() {
		if (this.arrowNode) {
			this.arrowNode.classList.toggle('arrow--hovered');
		}
	}

	@action
	selectItem(item: OptionRaw<number>): void {
		this.popupData.onChange(item);
		this.close();
	}

	@action
	setupView(node: HTMLElement) {
		this.arrowNode = node.closest('.popup-inner')?.querySelector('.arrow') || null;
	}
	<template>
		<ul {{didInsert this.setupView}}>
			{{#each this.options as |item index|}}
				{{#if (eq index 0)}}
					<li
						role="button"
						{{on "click" (fn this.selectItem item)}}
						{{on "mouseenter" this.toggleHoverClass}}
						{{on "mouseleave" this.toggleHoverClass}}
					>
						<strong>{{item.label}}</strong>
						<p>{{item.description}}</p>
					</li>
				{{else}}
					<li role="button" {{on "click" (fn this.selectItem item)}}>
						<strong>{{item.label}}</strong>
						<p>{{item.description}}</p>
					</li>
				{{/if}}
			{{/each}}
		</ul>
	</template>
}
